import * as React from 'react';
import NewOrderPageView from '../layouts/NewOrderPageView';
import { RowDataLive } from 'src/reducers/liveorderfile';
// import { UserDetail } from '../../reducers/user';

export interface NewOrderPageViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    newOrderData: RowDataLive[];
    reload: () => void;
    // onRowClick: (orderid: string, rowData: string) => void;
    // onDownloadClick: (orderno: string, fileName: string) => void;
    submitCancel: (column: Object) => void;
}

class NewOrdersPage extends React.Component<NewOrderPageViewProps> {
    render() {
        return (
            <NewOrderPageView
                // onRowClick={this.props.onRowClick}
                newOrderData={this.props.newOrderData}
                reload={this.props.reload}
                submitCancel={this.props.submitCancel}
            // onDownloadClick={this.props.onDownloadClick}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default NewOrdersPage;



// WEBPACK FOOTER //
// ./src/components/NewOrdersPage/NewOrdersPage.tsx